import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">最新动态</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">香蕉影视平台与内容的最新资讯，不错过每一个精彩瞬间</p>
        </div>

        <div className="relative pl-8 border-l-2 border-primary-200">
          {updatesData.map((item, i) => (
            <div key={i} className={`relative pb-8 ${i === updatesData.length - 1 ? 'pb-0' : ''}`}>
              <div className="absolute -left-[29px] top-1 w-4 h-4 rounded-full bg-primary-500 border-2 border-background-100"></div>
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5 hover:border-primary-200 transition-all duration-300">
                <span className="inline-block px-2.5 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-2 whitespace-nowrap">{item.date}</span>
                <p className="text-foreground-700 text-sm md:text-base leading-relaxed">{item.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}